import React from 'react';
import { IMPERILED_SPECIES_PALETTE } from '../../lib/imperiledSpeciesColors';
import { LegendCard } from './LegendCard';
import { CategoricalLegend } from './CategoricalLegend';

/**
 * Floating legend for the MoBI (Map of Biodiversity Importance) overlay.
 * The overlay is colored by each pixel's national PWRSR class (same 5-bucket
 * classification the left-panel bar chart uses, derived from the positive-
 * value percentile cuts of the CONUS raster), so the legend is a simple
 * categorical swatch list.
 */
export const ImperiledSpeciesMapLegend: React.FC = () => (
  <LegendCard title="PWRSR class — national" positioned>
    <CategoricalLegend palette={IMPERILED_SPECIES_PALETTE} />
  </LegendCard>
);
